export function mergeClassNames(
  baseClassName: string | undefined,
  extraClassNames: { [prop: string]: boolean | string | undefined }
): string {
  return Object.entries(extraClassNames).reduce((acc, b) => (b[1] ? `${acc} ${b[0]}` : acc), baseClassName ?? '');
}
